import _ from 'lodash';
// @mui
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
//components
import { fieldProps } from 'components/FormCreator/types';
import { useTheme, Box, Stack, Typography } from '@mui/material';

export interface radioProps {
	handleChange: any;
	options: { value: any; label: string; disabled?: boolean }[];
	value: any;
	label: string;
	name: string;
	disabled?: boolean;
	translation?: any;
	required?: boolean;
	flex?: string;
}

export default function RadioSelector(props: radioProps) {
	const { value, options = [], handleChange, label, name, translation, required = false, flex } = props;
	const theme = useTheme();
	return (
		<FormControl fullWidth>
			<Typography variant={'boldBody1'} sx={{ color: theme.palette.root.basicDeeoGreen }}>
				{required ? '*' : ''}
				{label}
			</Typography>
			<Stack direction={flex || 'row'} spacing={1}>
				{options.map((option, i) => (
					<Box
						key={i}
						className="customRadioWrap"
						sx={{
							width: flex === 'column' ? '100%' : '50%',
							border: '1px solid #cbdcde',
							height: theme.sizes.INPUT_HIGHT + 'px',
							borderRadius: '8px',
							backgroundColor: _.isEqual(value, option.value)
								? theme.palette.root.brandSecondary_012
								: 'inherit',
							'& .MuiFormControlLabel-root': {
								margin: 'auto',
								height: 'inherit',
							},
							'& .MuiRadio-root': {
								[theme.breakpoints.down('sm')]: { padding: '4px' },
							},
						}}
					>
						<FormControlLabel
							name={name}
							key={option.value}
							value={option.value}
							control={
								<Radio
									disabled={option?.disabled}
									onClick={handleChange}
									name={name}
									checked={_.isEqual(value, option.value)}
								/>
							}
							label={translation ? translation(option.label) : option.label}
						/>
					</Box>
				))}
			</Stack>
		</FormControl>
	);
}
